import React from 'react'
import * as UIcons from '@iconscout/react-unicons'

export default function DetailDrawer({ title, onClose, children, footer }) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-30 z-[5000]" onClick={onClose}>
      <div
        className="absolute top-0 right-0 h-full w-full max-w-md bg-white shadow-xl flex flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-5 border-b border-border-lines">
          <h3 className="text-lg font-bold text-dark-blue">{title}</h3>

          <button type="button" onClick={onClose} className="text-secondary hover:text-dark-blue">
            <UIcons.UilTimes size={20} />
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-2">
          {children}
        </div>

        {
          footer && (
            <div className="flex items-center gap-2 px-6 py-5 border-t border-border-lines">
              {footer}
            </div>
          )
        }
      </div>
    </div>
  )
}
